<div
  *ngIf="isDataLoaded && (showTip || showCategoryToggle)"
  class="d-flex justify-content-between align-items-center mt-3 mb-3"
>
  <div
    class="mr-auto pl-1"
    *ngIf="showTip"
    style="
      font-style: italic;
      font-size: 16px;
      font-family: Roboto, 'Helvetica Neue', sans-serif;
    "
  >
    <mat-icon class="pl-1 pr-1" style="font-size: 20px"
      >lightbulb_outline</mat-icon
    >
    Select a template to create an Assessment
  </div>
  <div class="ml-auto pr-3" *ngIf="showCategoryToggle">
    <mat-slide-toggle (click)="toggleView()"
      >View by categories</mat-slide-toggle
    >
  </div>
</div>
<div class="mt-2" *ngIf="isDataLoaded && !(filteredTemplate?.length === 0)">
  <div *ngIf="isCategoryView" class="accordion" id="accordionPanel">
    <div
      *ngFor="let category of filteredTemplate; let i = index"
      class="accordion-item"
    >
      <h2 class="accordion-header" id="heading{{ i }}">
        <button
          class="accordion-button {{ i === 0 ? '' : 'collapsed' }}"
          type="button"
          data-bs-toggle="collapse"
          attr.data-bs-target="#collapse{{ i }}"
          aria-expanded="{{ i == 0 ? 'true' : 'false' }}"
          aria-controls="collapse{{ i }}"
          style="font-size: 13px; font-weight: 700"
        >
          {{ category.category }}
        </button>
      </h2>
      <div
        id="collapse{{ i }}"
        class="accordion-collapse collapse {{ i === 0 ? 'show' : '' }}"
        aria-labelledby="heading{{ i }}"
        data-bs-parent="#accordionPanel"
      >
        <div class="accordion-body p-2">
          <div class="flex-container-1">
            <div
              class="flex-item p-1"
              *ngFor="let x of category.templates; let i = index"
              (click)="previewAssessment(x, x.tag_ids)"
              style="position: relative"
            >
              <div
                style="
                  position: relative;
                  cursor: pointer;
                  padding: 10px;
                  height: 13rem;
                  border-radius: 10px;
                  background-size: cover;
                  background-position: center;
                  overflow: hidden;
                  border: 0.5px solid grey;
                "
                [ngStyle]="{ 'background-color': x.color }"
              >
                <!-- <div style="color: white" class="mb-3"> -->
                <div class="mb-3 d-flex gap-2">
                  <!-- Factors -->
                  <div class="stat-box" style="margin-top: 5px">
                    <div class="stat-label"># Factors</div>
                    <div class="stat-value">{{ x.questions.length | appFormat: 'number' }}</div>
                  </div>
                </div>
                <!-- </div> -->
                <div style="color: white">
                  <h5 style="font-size: 11px" class="m-0">Created Date</h5>
                  <h4 style="font-size: 13px">
                    {{ x.created_on | appFormat: 'date' }}
                  </h4>
                </div>
                <div
                  class="mb-0 mt-2 trn-ph"
                  style="color: white"
                  *ngIf="x.created_by"
                >
                  <div class="d-flex align-items-center">
                    <mat-icon class="small-icon mr-1">perm_identity</mat-icon>
                    <span style="font-size: 11px">Owner</span>
                  </div>
                  <span
                    style="display: flex; font-weight: 700; font-size: 13px"
                  >
                    {{ x.created_by.first_name + " " + x.created_by.last_name }}
                  </span>
                </div>
                <div class="overlayer"></div>
                <div
                  style="
                    position: absolute;
                    width: 100%;
                    background: #0000008c;
                    padding: 10px;
                    border-bottom-left-radius: 10px;
                    border-bottom-right-radius: 10px;
                    bottom: 0;
                    left: 0;
                    height: 40px;
                    font-size: 10px;
                    align-items: center;
                    display: flex;
                    justify-content: center;
                  "
                >
                  <h6
                    class="mb-0"
                    style="
                      font-weight: 800;
                      font-size: 12px;
                      color: white;
                      text-align: center;
                      height: 43px;
                      overflow: hidden;
                      display: flex;
                      align-items: center;
                    "
                  >
                    {{ x.name }}
                  </h6>
                </div>
              </div>

              <div class="action-vert">
                <button
                  mat-icon-button
                  color="warn"
                  style="height: 15px; width: 15px"
                >
                  <mat-icon
                    (click)="
                      downloadTemplate(x.id, x.file_name);
                      $event.stopPropagation()
                    "
                    style="font-size: 15px"
                    >download</mat-icon
                  >
                </button>
                <button
                  mat-icon-button
                  color="warn"
                  style="height: 15px; width: 15px"
                >
                  <mat-icon
                    (click)="
                      deleteTemplate(x.id, x.name, i); $event.stopPropagation()
                    "
                    style="font-size: 15px; color: red"
                    >delete</mat-icon
                  >
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!isCategoryView">
    <div class="flex-container-1">
      <div
        class="flex-item p-1"
        *ngFor="let x of unCategorizedTemplates; let i = index"
        (click)="previewAssessment(x, x.tag_ids)"
        style="position: relative"
      >
        <div
          style="
            position: relative;
            cursor: pointer;
            padding: 10px;
            height: 13rem;
            border-radius: 10px;
            background-size: cover;
            background-position: center;
            overflow: hidden;
            border: 0.5px solid grey;
          "
          [ngStyle]="{ 'background-color': x.color }"
        >
          <!-- <div style="color: white" class="mb-3"> -->
          <div class="mb-3 d-flex gap-2">
            <!-- Factors -->
            <div class="stat-box" style="margin-top: 5px">
              <div class="stat-label"># Factors</div>
              <div class="stat-value">{{ x.questions.length | appFormat: 'number' }}</div>
            </div>
          </div>
          <!-- </div> -->
          <div style="color: white">
            <h5 style="font-size: 11px" class="m-0">Created Date</h5>
            <h4 style="font-size: 13px">
              {{ x.created_on | appFormat: 'date' }}
            </h4>
          </div>
          <div
            class="mb-0 mt-2 trn-ph"
            style="color: white"
            *ngIf="x.created_by"
          >
            <div class="d-flex align-items-center">
              <mat-icon class="small-icon mr-1">perm_identity</mat-icon>
              <span style="font-size: 11px">Owner</span>
            </div>
            <span style="display: flex; font-weight: 700; font-size: 13px">
              {{ x.created_by.first_name + " " + x.created_by.last_name }}
            </span>
          </div>
          <div class="overlayer"></div>
          <div
            style="
              position: absolute;
              width: 100%;
              background: #0000008c;
              padding: 10px;
              border-bottom-left-radius: 10px;
              border-bottom-right-radius: 10px;
              bottom: 0;
              left: 0;
              height: 40px;
              font-size: 10px;
              align-items: center;
              display: flex;
              justify-content: center;
            "
          >
            <h6
              class="mb-0"
              style="
                font-weight: 800;
                font-size: 12px;
                color: white;
                text-align: center;
                height: 43px;
                overflow: hidden;
                display: flex;
                align-items: center;
              "
            >
              {{ x.name }}
            </h6>
          </div>
        </div>
        <div class="action-vert">
          <button
            mat-icon-button
            color="warn"
            style="height: 15px; width: 15px"
          >
            <mat-icon
              (click)="
                downloadTemplate(x.id, x.file_name); $event.stopPropagation()
              "
              style="font-size: 15px"
              >download</mat-icon
            >
          </button>
          <button
            mat-icon-button
            color="warn"
            style="height: 15px; width: 15px"
          >
            <mat-icon
              (click)="
                deleteTemplate(x.id, x.name, i); $event.stopPropagation()
              "
              style="font-size: 15px; color: red"
              >delete</mat-icon
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isDataLoaded && filteredTemplate?.length === 0" class="text-center">
  {{ commonText.no_records_found}}
</div>
